import * as R from "ramda";
import moment from "moment";
import { Button, Drawer, Empty, Modal, Spin, Table, Tag } from "antd";
import React, { Fragment, useCallback, useEffect, useState } from "react";

import { useGet } from "@/containers/Video/aliyun-service-api";
import { RatioImage } from "@/containers/Video/widgets/ratio-image";
import { BaseTypeCarousel } from "@/containers/Video/tab-pages/base-type";
import { SelectedCard } from "@/containers/Video/widgets/selected-card-list";
import { getTemplateCover } from "@/containers/Video/tab-pages/video-template";
import { YYYYMMDDHHmmss } from "@/containers/Video/widgets/base-type-carousel-item-video";

export const CountDownRefresh = ({
  onTrigger,
  children = R.T,
  countDownSeconds = 30,
}) => {
  const [countDown, setCountDown] = useState(countDownSeconds);

  useEffect(() => {
    const timer = setInterval(() => {
      setCountDown((prevCount) => {
        if (prevCount === 1) {
          clearInterval(timer);
          onTrigger();
          return countDownSeconds;
        }
        return prevCount - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [countDownSeconds, onTrigger]);

  const handleClick = () => {
    setCountDown(countDownSeconds);
    onTrigger();
  };

  return <div onClick={handleClick}>{children({ countDown })}</div>;
};
/**
 * {
 *       "id": 3,
 *       "order_id": 116391,
 *       "status": 0,
 *       "media_id": 915,
 *       "template_id": 1,
 *       "title": "title2024_11_15_15_05_38",
 *       "path": "915/20241115150538.mp4",
 *       "result": "",
 *       "gold_string": [
 *         {
 *           "text": "让我们一起创造更美好的未来！",
 *           "endTime": 65,
 *           "startTime": 55
 *         },
 *         {
 *           "text": "梦想在远方，路在脚下，勇往直前！",
 *           "endTime": 130,
 *           "startTime": 120
 *         },
 *         {
 *           "text": "每一次努力，都是通往成功的坚实步伐。",
 *           "endTime": 190,
 *           "startTime": 180
 *         },
 *         {
 *           "text": "相信自己，你比想象中更强大！",
 *           "endTime": 250,
 *           "startTime": 240
 *         }
 *       ],
 *       "CreatedAt": "2024-11-15T15:05:39+08:00",
 *       "UpdatedAt": "2024-11-15T15:05:39+08:00",
 *       "DeletedAt": null
 *     }
 * @param props
 * @returns {Element}
 * @constructor
 */

export const SingleTemplateCard = (props) => {
  const job = R.pathOr({}, ["detail"], props);
  const rowKey = R.pathOr("id", ["rowKey"], props);
  const selectedRowKeys = R.pathOr([], ["selectedRowKeys"], props);
  const setSelectedRowKeys = R.pathOr(R.T, ["setSelectedRowKeys"], props);
  return (
    <SelectedCard
      title={job.name}
      style={{ margin: 16 }}
      hoverable
      size="small"
      active={selectedRowKeys.includes(R.prop(rowKey, job))}
      onClick={() => {
        setSelectedRowKeys([R.prop(rowKey, job)]);
      }}
    >
      {props.model ? (
        <TemplateContentModel {...props} />
      ) : (
        <TemplateContent {...props} />
      )}
    </SelectedCard>
  );
};

export const TemplateContentModel = (props) => {
  const template = R.pathOr({}, ["detail"], props);
  return (
    <Fragment>
      <p>模板ID: {template.id}</p>
      <p>
        创建时间:{" "}
        {R.pipe(R.prop("CreatedAt"), (v) =>
          moment(v).format("YYYY-MM-DD HH:mm:ss")
        )(template)}
      </p>
      <RatioImage ratio={200 / 240} src={getTemplateCover(template)} />
    </Fragment>
  );
};

export const JobStatusMap = {
  0: "处理中",
  1: "处理成功",
};

export const ViewVideo = ({ src, children = R.T }) => {
  const [visible, setVisible] = useState(false);

  return (
    <Fragment>
      {visible ? (
        <Modal
          visible
          onCancel={() => setVisible(false)}
          title="查看智能生产作品详情"
        >
          <div
            style={{
              display: "flex",
              justifyContent: "center",
            }}
          >
            <video
              src={src}
              controls
              autoPlay
              style={{
                maxWidth: "100%",
                maxHeight: "60vh",
              }}
            />
          </div>
        </Modal>
      ) : null}
      {children({ open: () => setVisible(true) })}
    </Fragment>
  );
};

export const RenderView = (props) => {
  const { job, updateOne = R.T, setIsPreview = R.T } = props;
  const [previewIndex, setPreviewIndex] = useState(-1);

  useEffect(() => {
    setIsPreview(previewIndex > -1);
  }, [previewIndex]);

  return (
    <Fragment>
      <BaseTypeCarousel
        type="video"
        current={previewIndex}
        dataSource={[R.pathOr({}, ["composition_media_detail"], job)]}
        setPreviewIndex={setPreviewIndex}
        loading={false}
        {...R.omit(["detail"], props)}
        updateOne={(newDetail) => {
          updateOne(job.id, newDetail);
        }}
      />
      <a
        onClick={() => {
          setPreviewIndex(0);
        }}
      >
        查看
      </a>
    </Fragment>
  );
};

export const TemplateContent = (props) => {
  const job = R.pathOr({}, ["detail"], props);
  return (
    <Fragment>
      <p>
        当前状态:{" "}
        {(() => {
          switch (job.status) {
            case 0:
              return <Tag color="orange">{JobStatusMap[job.status]}</Tag>;
            case 1:
              return <RenderView {...props} job={job} />;
            default:
              return null;
          }
        })()}
      </p>
      <p>
        创建时间:{" "}
        {R.pipe(R.prop("CreatedAt"), (v) =>
          moment(v).format("YYYY-MM-DD HH:mm:ss")
        )(job)}
      </p>
    </Fragment>
  );
};

export const VideoTemplateJob = (props) => {
  const orderId = R.pathOr("", ["match", "params", "orderid"], props) * 1;

  const [jobList, setJobList] = useState([]);
  const [refreshId, setRefreshId] = useState(0);

  const [isPreview, setIsPreview] = useState(false);

  const { loading } = useGet(
    `/api/v2/goldstringjob/order/${orderId}/list`,
    {},
    (list) => {
      setJobList(
        list.map((item) => {
          return {
            ...item,
            status: (() => {
              if (item.status === 0) {
                return 0;
              }
              if (
                item.status === 1 &&
                R.pipe(
                  R.pathOr({}, ["composition_media_detail"]),
                  R.isEmpty
                )(item)
              ) {
                return 0;
              }
              return 1;
            })(),
          };
        })
      );
    },
    [refreshId]
  );

  const updateOne = useCallback(
    (id, composition_media_detail) => {
      setJobList(
        R.map((job) => {
          if (job.id === id) {
            return {
              ...job,
              composition_media_detail,
            };
          }
          return job;
        }, jobList)
      );
    },
    [jobList]
  );

  if (!loading && jobList.length === 0) {
    return (
      <div
        style={{
          padding: "200px 0",
        }}
      >
        <Empty description={null} />
      </div>
    );
  }

  return (
    <Spin spinning={loading}>
      <div
        style={{
          marginLeft: 32,
          marginTop: 16,
        }}
      >
        {!isPreview && (
          <CountDownRefresh
            onTrigger={() => {
              setRefreshId(R.inc);
            }}
          >
            {({ countDown }) => {
              return (
                <Button
                  onClick={() => {
                    setRefreshId(R.inc);
                  }}
                >
                  刷新 {countDown}
                </Button>
              );
            }}
          </CountDownRefresh>
        )}
      </div>
      {/*文件名 状态 创建时间 操作*/}

      <Table
        dataSource={jobList}
        rowKey="id"
        columns={[
          {
            title: "文件名",
            dataIndex: "name",
          },
          {
            title: "状态",
            dataIndex: "status",
            render: (status) => {
              return (
                <Tag color={status === 0 ? "orange" : "green"}>
                  {JobStatusMap[status]}
                </Tag>
              );
            },
          },
          {
            title: "创建时间",
            dataIndex: "CreatedAt",
            render: (createdAt) => {
              return moment(createdAt).format(YYYYMMDDHHmmss);
            },
          },
          {
            title: "操作",
            dataIndex: "id",
            render: (id, item) => {
              if (item.status === 0) {
                return null;
              }
              return (
                <RenderView
                  setIsPreview={setIsPreview}
                  updateOne={updateOne}
                  job={item}
                  {...R.omit(["detail"], props)}
                />
              );
            },
          },
        ]}
      />
    </Spin>
  );
};

export const DrawerOfVideoTemplateJob = (props) => {
  const [visible, setVisible] = useState(false);
  const open = () => setVisible(true);
  return (
    <Fragment>
      <Drawer
        visible={visible}
        onClose={() => setVisible(false)}
        title="合成任务"
        footer={null}
        width={800}
      >
        <VideoTemplateJob {...props} />
      </Drawer>
      {props.children({ open })}
    </Fragment>
  );
};



// WEBPACK FOOTER //
// ./src/containers/Video/tab-pages/video-template-job.js